import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SalaryService {

  constructor(private http: HttpClient) { }


  GetRecord(year: number): Observable<Array<any>> {
    return this.http.get(environment.BaseUrl + "Daro/Salary?year=" + year).pipe(
        map(data => {
          return data as Array<any>
        })
      )
  }

  GetSingle(year: number): Observable<Array<any>> {
    return this.http.get(environment.BaseUrl + "Daro/Salary/GetSingle?year=" + year).pipe(
        map(data => {
          return data as Array<any>
        })
      )
  }

  GetSinglePerson(year: number, personId: number): Observable<Array<any>> {
    return this.http.get(environment.BaseUrl + "Daro/Salary/GetSinglePerson?year=" + year + "&personId=" + personId).pipe(
        map(data => {
          return data as Array<any>
        })
      )
  }


  Add(model: any): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      model: model,
    }


    return this.http.post(environment.BaseUrl + "Daro/Salary/Add", body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }

  AddPerson(model: any): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {
      model: model,
    }

    return this.http.post(environment.BaseUrl + "Daro/Salary/AddPerson", body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }





  GetEzafekar(year: number, month: number): Observable<Array<any>> {
    return this.http.get(environment.BaseUrl + "Daro/Salary/GetEzafekar?year=" + year
      + "&month=" + month).pipe(
        map(data => {
          return data as Array<any>
        })
      )
  }

  AddEzafekar(model: any): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {
      model: model,
    }

    return this.http.post(environment.BaseUrl + "Daro/Salary/AddEzafekar", body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }



  GetDay(year: number, month: number): Observable<Array<any>> {
    return this.http.get(environment.BaseUrl + "Daro/Salary/GetDay?year=" + year
      + "&month=" + month).pipe(
        map(data => {
          return data as Array<any>
        })
      )
  }

  AddDay(model: any): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {
      model: model,
    }


    return this.http.post(environment.BaseUrl + "Daro/Salary/AddDay", body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }



  GetSalaryMonth(year: number, month: number): Observable<Array<any>> {
    return this.http.get(environment.BaseUrl + "Daro/Salary/GetSalaryMonth?month=" + month
      + "&year=" + year).pipe(
        map(data => {
          return data as Array<any>
        })
      )
  }


  GetSalaryMonthFish(year: number, month: number, id: number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Salary/GetSalaryMonthFish?month=" + month
      + "&id=" + id
      + "&year=" + year).pipe(
        map(data => {
          return data as any
        })
      )
  }




  GetSanavat(year: number): Observable<Array<any>> {
    return this.http.get(environment.BaseUrl + "Daro/Salary/GetSanavat?year=" + year).pipe(
        map(data => {
          return data as Array<any>
        })
      )
  }

  AddSanavat(model: any): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {
      model: model,
    }


    return this.http.post(environment.BaseUrl + "Daro/Salary/AddSanavat", body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }

}
